export default __webpack_public_path__ + "static/media/cotract_mini_feature_graphic.247127a4.png";